import axios from "axios"
import {checkAgreement, checkInput, isValidForm, loadCaptchaToken} from "../../helpers"

$(document).ready(function() {
    const $formBase = $(".js-form-feedback");
    const $modal = $(".js-modal-alert");

    $formBase.each(function() {
        const $form = $(this);
        const $button = $form.find(".js-form-send");
        const $agreementNode = $form.find("[name=agreement]");
        let url = $form.attr("action");

        checkAgreement($agreementNode, $button);
        checkInput($form);

        $form.find("input[type=text]").on("focus", function() {
            loadCaptchaToken();
        });

        $form.on("submit", function(e) {
            e.preventDefault();
            let formData = new FormData(this);
            let errorBox = $form.find(".js-form-error")

            if (isValidForm($form)) {
                $button.addClass("disabled");
                errorBox.html("");
                errorBox.hide();
                axios({
                    url: url,
                    data: formData,
                    method: "post",
                }).then(res => {
                    $button.removeClass("disabled");
                    if (res.data.status === "success") {
                        $form.trigger("reset");
                        const $modalForm = $(".js-modal-form");
                        if ($modalForm.length > 0) {
                            $(".js-modal-form").addClass("fade-out")
                                .removeClass("fade-in");
                            setTimeout(() => {
                                $(".js-modal-form").removeClass("opened");
                            }, 500);
                        }
                        $modal.find(".js-modal-text").html(res.data.data.message);
                        $modal.addClass("fade-in opened").removeClass("fade-out");
                    } else {
                        let errors = res.data.data.errors;
                        errorBox.html(res.data.data.message);
                        errorBox.fadeIn();

                        if (Object.keys(errors).length > 0) {
                            for (let key of Object.keys(errors)) {
                                $form.find("[name=" + key + "]")
                                    .addClass("invalid")
                                    .siblings(".error")
                                    .text(errors[key]);
                            }
                        }
                    }

                }).catch((e) => {
                    console.log(e);
                    alert("Что-то пошло не так...\nПопробуйте обновить страницу");
                    $button.removeClass("disabled");
                });
                loadCaptchaToken();
            }
        });
    });
});
